import { render, staticRenderFns } from "./ProductInformation.vue?vue&type=template&id=f988a37a&"
import script from "./ProductInformation.vue?vue&type=script&lang=js&"
export * from "./ProductInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports